import React, { useCallback } from "react";

import Popconfirm from "antd/es/popconfirm";
import Tooltip from "antd/es/tooltip";

import { RawFile } from "@mapmycustomers/shared/types/File";
import { FileIcon } from "@mapmycustomers/ui";

import canPreview from "@app/component/FilePreview/canPreview";

import styles from "./FileItem.module.scss";

interface Props {
  file: RawFile;
  onDownload?: (file: RawFile) => void;
  onPreview?: (file: RawFile) => void;
}

const FileItem: React.FC<Props> = ({ file, onDownload, onPreview }) => {
  const previewable = canPreview(file);

  const handleDownloadFile = useCallback(() => {
    onDownload?.(file);
  }, [file, onDownload]);

  const handlePreviewFile = useCallback(() => {
    onPreview?.(file);
  }, [file, onPreview]);

  return (
    <Popconfirm
      onConfirm={handleDownloadFile}
      placement="bottom"
      title={"Download file?"}
      trigger={previewable ? [] : ["click"]}
    >
      <div className={styles.container} onClick={previewable ? handlePreviewFile : undefined}>
        <FileIcon className={styles.icon} file={file} />
        <Tooltip title={file.name}>
          <div className={styles.label}>{file.name}</div>
        </Tooltip>
      </div>
    </Popconfirm>
  );
};

export default FileItem;
